// Define the types for the testimonials
export interface Testimonial {
    commentFr: string;
    commentEn: string;
    commenter: string;
    note: number;
    dateFr: string;
    dateEn: string;
    source: string;
  }
  
  // Testimonial data array


  export const trustTestimonialData: Testimonial[] = [
    {
        "commentFr": "Les vidéos des annonces m'ont totalement rassuré ! Pouvoir visiter virtuellement mon appartement à Douala avant de réserver a éliminé toute inquiétude. Exactement comme dans les vidéos !",
        "commentEn": "The listing videos completely reassured me! Being able to virtually tour my Douala apartment before booking eliminated all worries. Exactly as shown in the videos!",
        "commenter": "Émilie T.",
        "note": 5,
        "dateFr": "Mars 2024",
        "dateEn": "March 2024",
        "source": "Google"
    },
    {
        "commentFr": "Le support 24/7 a résolu mon problème de paiement en 15 minutes. Impressionné par leur réactivité et professionnalisme ! Paiement mobile money sécurisé et efficace.",
        "commentEn": "The 24/7 support resolved my payment issue in 10 minutes. Impressed by their responsiveness and professionalism! Secure mobile money payment worked flawlessly.",
        "commenter": "Kwame B.",
        "note": 5,
        "dateFr": "Avril 2024",
        "dateEn": "April 2024",
        "source": "Google"
    },
    {
        "commentFr": "Chaque détail correspondait parfaitement aux photos et vidéos. La visite virtuelle m'avait même montré des angles que j'aurais oublié de vérifier en personne !",
        "commentEn": "Every detail matched the photos and videos perfectly. The virtual tour even showed angles I would have forgotten to check in person!",
        "commenter": "Nadia K.",
        "note": 5,
        "dateFr": "Février 2024",
        "dateEn": "February 2024",
        "source": "Google"
    },
    {
        "commentFr": "J'ai adoré payer par Orange Money - simple et instantané. Le service client m'a guidé étape par étape pour ma première réservation. Une expérience sans stress !",
        "commentEn": "Loved paying with Orange Money - simple and instant. The customer service team guided me step-by-step through my first booking. A stress-free experience!",
        "commenter": "Ousmane D.",
        "note": 5,
        "dateFr": "Janvier 2024",
        "dateEn": "January 2024",
        "source": "Google"
    },
    {
        "commentFr": "La vidéo de la piscine était si détaillée que j'ai compté les transats ! Aucune mauvaise surprise à l'arrivée. Vraiment une plateforme transparente.",
        "commentEn": "The pool video was so detailed I could count the lounge chairs! No bad surprises upon arrival. Truly a transparent platform.",
        "commenter": "Léa M.",
        "note": 5,
        "dateFr": "Mai 2024",
        "dateEn": "May 2024",
        "source": "Google"
    },
    {
        "commentFr": "Un problème à 23h ? Le support a répondu en 3 minutes ! Paiement MTN Mobile Money sécurisé et confirmation immédiate. Ce niveau de service est exceptionnel.",
        "commentEn": "An issue at 11PM? Support responded in 3 minutes! Secure MTN Mobile Money payment with instant confirmation. This service level is exceptional.",
        "commenter": "Abdoul G.",
        "note": 5,
        "dateFr": "Juin 2024",
        "dateEn": "June 2024",
        "source": "Google"
    },
    {
        "commentFr": "Les vidéos à 360° permettent de vérifier chaque coin. J'ai repéré la machine à café exactement où elle apparaissait dans la visite virtuelle !",
        "commentEn": "The 360° videos let me check every corner. I spotted the coffee machine exactly where it appeared in the virtual tour!",
        "commenter": "Camille R.",
        "note": 5,
        "dateFr": "Avril 2024",
        "dateEn": "April 2024",
        "source": "Google"
    },
    {
        "commentFr": "Paiement par Mobile Money  accepté ! Enfin une plateforme qui comprend les réalités bancaires africaines. Les transferts instantanés m'ont évité bien des tracas.",
        "commentEn": "Local mobile Money payments accepted! Finally a platform that understands African banking realities. Instant transfers saved me so much hassle.",
        "commenter": "Kofi A.",
        "note": 5,
        "dateFr": "Mars 2024",
        "dateEn": "March 2024",
        "source": "Google"
    },
    {
        "commentFr": "Le comparatif vidéo entre 3 appartements m'a aidé à choisir en toute confiance. Les mesures précises montrées dans la vidéo correspondaient au centimètre près !",
        "commentEn": "The video comparison between 3 apartments helped me choose confidently. The exact measurements shown in the video matched to the centimeter!",
        "commenter": "Aminata S.",
        "note": 5,
        "dateFr": "Février 2024",
        "dateEn": "February 2024",
        "source": "Google"
    },
    {
        "commentFr": "J'ai vérifié chaque prise électrique grâce au zoom de la vidéo - tout fonctionnait parfaitement ! Une transparence rare sur d'autres plateformes.",
        "commentEn": "I checked every power outlet using the video zoom - all worked perfectly! A level of transparency rarely seen on other platforms.",
        "commenter": "Marc T.",
        "note": 5,
        "dateFr": "Janvier 2024",
        "dateEn": "January 2024",
        "source": "Google"
    }
];

export const testimonialData: Testimonial[] = [
        
      {
          "commentFr": "AfriqPnB est probablement la meilleure plateforme logistique que le Cameroun et l'Afrique connaîtront dans les années 2020 et 2030. Il n'y a rien de tel que de trouver le bon service pour faciliter et apporter un super confort à notre vie de voyage...👌🔥",
          "commentEn": "Africa is Proud n Beautiful is most probably the best logistics platform Cameroon & Africa would get to experience 2020s & 2030s. There's nothing like finding the right service to facilitate & provide super comfort to our travel life...👌🔥",
          "commenter": "Passion Fruit",
          "note": 5,
          "dateFr": "Juin 2023",
          "dateEn": "June 2023",
          "source": "Google"
      },
      {
          "commentFr": "Mon séjour a été vraiment spécial, même si ça a mal commencé😂, mais vous avez su faire preuve de professionnalisme en résolvant dans l'immédiat le problème. Mise à part ça ce séjour était vraiment esquis et j'ai prévu revenir à Kribi en août avec des amis et séjourner toujours à la résidence.",
          "commentEn": "My stay was really special, even though it started badly😂, but you showed professionalism by immediately solving the problem. Apart from that, this stay was really exquisite and I plan to return to Kribi in August with friends and stay at the residence again.",
          "commenter": "TamSir",
          "note": 4,
          "dateFr": "Avril 2023",
          "dateEn": "April 2023",
          "source": "Google"
      },
      {
          "commentFr": "Bonjour, Que dire d'AfriqPnB, que dire?\n\nLes mots qui me viennent tout de suite sont: efficacité, professionnalisme, accompagnement, satisfaction client.\n\nL'expérience que j’ai vécue avec AfriqPnB m'emmène à dire que c'est la plateforme incontournable. C'est celle que je recommande.",
          "commentEn": "Hello, what to say about AfriqPnB, what to say?\n\nThe words that come to me right away are: efficiency, professionalism, support, customer satisfaction.\n\nThe experience I had with AfriqPnB leads me to say that it is the essential platform. It is the one I recommend.",
          "commenter": "Cécile N",
          "note": 5,
          "dateFr": "Juin 2023",
          "dateEn": "June 2023",
          "source": "Google"
      },
      {
          "commentFr": "Agréablement surpris par le confort à la Résidence Samory et la convivialité des responsables. L'appart était conforme à ce que j'ai vu sur AfriqPnB et la navigation sur le site était conviviale. Je recommanderai à mes proches !",
          "commentEn": "Pleasantly surprised by the comfort at Residence Samory and the friendliness of the managers. The apartment was as seen on AfriqPnB and the site navigation was user-friendly. I will recommend it to my loved ones!",
          "commenter": "Léopold M.",
          "note": 5,
          "dateFr": "Juin 2023",
          "dateEn": "June 2023",
          "source": "Google"
      },
      {
          "commentFr": "Site au top. les maisons proposées sont fidèles aux photos sur le site. Pour ma part j'ai occupé un bel appartement avec piscine au bord de mer à Kribi. Je le recommande vivement",
          "commentEn": "Great site. The houses offered match the photos on the site. Personally, I stayed in a beautiful apartment with a pool by the sea in Kribi. I highly recommend it.",
          "commenter": "Myriam G.",
          "note": 5,
          "dateFr": "Septembre 2023",
          "dateEn": "September 2023",
          "source": "Google"
      },
      {
          "commentFr": "AfriqPnB Cameroon est un merveille, ce site, j'ai pu pour trouver un magnifique appartement meublé à Douala. Merci encore à vous pour votre disponibilité 🙏🙏🙏",
          "commentEn": "AfriqPnB Cameroon is a marvel, I was able to find a beautiful furnished apartment in Douala. Thank you again for your availability 🙏🙏🙏",
          "commenter": "Olye De",
          "note": 5,
          "dateFr": "Juin 2023",
          "dateEn": "June 2023",
          "source": "Google"
      },
      {
          "commentFr": "L'appartement que nous avons pris était très beau, propre. La responsable était très accueillante et disponible.",
          "commentEn": "The apartment we took was very beautiful and clean. The manager was very welcoming and available.",
          "commenter": "camer kmer",
          "note": 5,
          "dateFr": "Juillet 2023",
          "dateEn": "July 2023",
          "source": "Google"
      },
      {
          "commentFr": "Bravo à AfriqPnB. Site très bien fonctionnel et les logements sur le site sont de très bonnes qualités.",
          "commentEn": "Bravo to AfriqPnB. Very functional site and the accommodations on the site are of very good quality.",
          "commenter": "Mathurin G.",
          "note": 5,
          "dateFr": "Juin 2023",
          "dateEn": "June 2023",
          "source": "Google"
      },
      {
          "commentFr": "Le site est bien fait, simple à utiliser, les photos sont claires et inspirent confiance. Je recommande ce site.",
          "commentEn": "The site is well done, easy to use, the photos are clear and inspire confidence. I recommend this site.",
          "commenter": "Liliane B.",
          "note": 5,
          "dateFr": "Août 2023",
          "dateEn": "August 2023",
          "source": "Google"
      },
      {
          "commentFr": "Site fiable et efficace, je recommande 👌🏽",
          "commentEn": "Reliable and efficient site, I recommend 👌🏽",
          "commenter": "Annie N.",
          "note": 5,
          "dateFr": "Septembre 2023",
          "dateEn": "September 2023",
          "source": "Google"
      },
      {
          "commentFr": "Les informations sont claires et précises, agréable",
          "commentEn": "The information is clear and precise, pleasant",
          "commenter": "ML Group",
          "note": 5,
          "dateFr": "Janvier 2024",
          "dateEn": "January 2024",
          "source": "Google"
      },
        {
            "commentFr": "Le service client d'AfriqPnB est exceptionnel ! J'ai eu un petit souci à mon arrivée, mais il a été résolu rapidement et avec professionnalisme. J'ai séjourné à Douala et je recommande vivement cette plateforme.",
            "commentEn": "AfriqPnB's customer service is exceptional! I had a small issue upon arrival, but it was quickly resolved with professionalism. I stayed in Douala and highly recommend this platform.",
            "commenter": "Jean-Luc B.",
            "note": 5,
            "dateFr": "Janvier 2024",
            "dateEn": "January 2024",
            "source": "Google"
        },
        {
            "commentFr": "Mon séjour à Kribi était encore mieux que ce que j'avais imaginé. Les photos correspondaient parfaitement à la réalité et les vidéos des annonces ont vraiment aidé à faire mon choix.",
            "commentEn": "My stay in Kribi was even better than I had imagined. The photos matched reality perfectly and the listing videos really helped me make my choice.",
            "commenter": "Aïcha S.",
            "note": 5,
            "dateFr": "Janvier 2024",
            "dateEn": "January 2024",
            "source": "Google"
        },
        {
            "commentFr": "Le paiement par mobile money est très pratique et sécurisant. J'ai passé un excellent séjour à Douala grâce à AfriqPnB. Je recommande vivement!",
            "commentEn": "Paying with mobile money is very convenient and secure. I had an excellent stay in Douala thanks to AfriqPnB. Highly recommend!",
            "commenter": "Hugo T.",
            "note": 5,
            "dateFr": "Février 2024",
            "dateEn": "February 2024",
            "source": "Google"
        },
        {
            "commentFr": "L'appartement était impeccable et conforme aux photos. AfriqPnB est définitivement ma plateforme préférée pour les réservations à Kribi.",
            "commentEn": "The apartment was spotless and as pictured. AfriqPnB is definitely my favorite platform for bookings in Kribi.",
            "commenter": "Laurent M.",
            "note": 5,
            "dateFr": "Février 2024",
            "dateEn": "February 2024",
            "source": "Google"
        },
        {
            "commentFr": "Le service client est très réactif et professionnel. J'ai eu une expérience agréable à Douala grâce à AfriqPnB.",
            "commentEn": "Customer service is very responsive and professional. I had a pleasant experience in Douala thanks to AfriqPnB.",
            "commenter": "Fatou D.",
            "note": 4,
            "dateFr": "Mars 2024",
            "dateEn": "March 2024",
            "source": "Google"
        },
        {
            "commentFr": "AfriqPnB propose des vidéos des annonces, ce qui m'a vraiment rassuré avant de réserver. J'ai passé un excellent séjour à Kribi.",
            "commentEn": "AfriqPnB offers videos of the listings, which really reassured me before booking. I had an excellent stay in Kribi.",
            "commenter": "Mamadou K.",
            "note": 5,
            "dateFr": "Mars 2024",
            "dateEn": "March 2024",
            "source": "Google"
        },
        {
            "commentFr": "Site fiable avec des logements conformes aux photos. Je recommande AfriqPnB pour un séjour sans surprises à Douala.",
            "commentEn": "Reliable site with accommodations that match the photos. I recommend AfriqPnB for a surprise-free stay in Douala.",
            "commenter": "Nathalie E.",
            "note": 5,
            "dateFr": "Avril 2024",
            "dateEn": "April 2024",
            "source": "Google"
        },
        {
            "commentFr": "L'expérience avec AfriqPnB a été fantastique. Les vidéos des annonces sont un vrai plus. Mon séjour à Kribi était parfait.",
            "commentEn": "The experience with AfriqPnB was fantastic. The listing videos are a real plus. My stay in Kribi was perfect.",
            "commenter": "Boris L.",
            "note": 5,
            "dateFr": "Avril 2024",
            "dateEn": "April 2024",
            "source": "Google"
        },
        {
            "commentFr": "J'ai beaucoup apprécié la possibilité de payer par mobile money. Cela rend le processus beaucoup plus simple et sécurisé. Merci AfriqPnB !",
            "commentEn": "I really appreciated the ability to pay with mobile money. It makes the process much simpler and more secure. Thank you AfriqPnB!",
            "commenter": "Salma F.",
            "note": 5,
            "dateFr": "Mai 2024",
            "dateEn": "May 2024",
            "source": "Google"
        },
        {
            "commentFr": "Les informations sur le site sont précises et fiables. Mon séjour à Douala a été conforme à mes attentes. Je recommande vivement AfriqPnB.",
            "commentEn": "The information on the site is accurate and reliable. My stay in Douala met my expectations. I highly recommend AfriqPnB.",
            "commenter": "Didier A.",
            "note": 5,
            "dateFr": "Mai 2024",
            "dateEn": "May 2024",
            "source": "Google"
        },
        {
            "commentFr": "Séjour agréable à Kribi grâce à AfriqPnB. Les photos correspondaient parfaitement à la réalité. Très satisfait !",
            "commentEn": "Pleasant stay in Kribi thanks to AfriqPnB. The photos matched reality perfectly. Very satisfied!",
            "commenter": "Claire J.",
            "note": 5,
            "dateFr": "Juin 2024",
            "dateEn": "June 2024",
            "source": "Google"
        },
        {
            "commentFr": "Le site AfriqPnB est très bien conçu et facile à utiliser. J'ai trouvé un superbe appartement à Douala. Merci !",
            "commentEn": "The AfriqPnB site is very well designed and easy to use. I found a great apartment in Douala. Thank you!",
            "commenter": "Georges B.",
            "note": 5,
            "dateFr": "Juin 2024",
            "dateEn": "June 2024",
            "source": "Google"
        },
        {
            "commentFr": "L'application AfriqPnB est très intuitive et les vidéos des annonces sont un vrai plus. Mon séjour à Kribi a été fantastique.",
            "commentEn": "The AfriqPnB app is very intuitive and the listing videos are a real plus. My stay in Kribi was fantastic.",
            "commenter": "Aminatou D.",
            "note": 5,
            "dateFr": "Janvier 2024",
            "dateEn": "January 2024",
            "source": "Google"
        },
        {
            "commentFr": "Le support client est excellent, toujours disponible pour aider. J'ai eu un séjour parfait à Douala grâce à AfriqPnB.",
            "commentEn": "Customer support is excellent, always available to help. I had a perfect stay in Douala thanks to AfriqPnB.",
            "commenter": "Pierre L.",
            "note": 5,
            "dateFr": "Février 2024",
            "dateEn": "February 2024",
            "source": "Google"
        },
        {
            "commentFr": "J'ai adoré mon séjour à Kribi. Les vidéos des annonces sur AfriqPnB m'ont vraiment aidé à choisir le bon endroit. Merci !",
            "commentEn": "I loved my stay in Kribi. The listing videos on AfriqPnB really helped me choose the right place. Thank you!",
            "commenter": "Sophia K.",
            "note": 5,
            "dateFr": "Février 2024",
            "dateEn": "February 2024",
            "source": "Google"
        },
        {
            "commentFr": "AfriqPnB offre une expérience utilisateur exceptionnelle. Les photos et vidéos des annonces sont très utiles. J'ai passé un excellent séjour à Douala.",
            "commentEn": "AfriqPnB offers an exceptional user experience. The photos and videos of the listings are very helpful. I had an excellent stay in Douala.",
            "commenter": "Yannick T.",
            "note": 5,
            "dateFr": "Mars 2024",
            "dateEn": "March 2024",
            "source": "Google"
        },
        {
            "commentFr": "Mon séjour à Kribi était parfait. Les photos et vidéos des annonces étaient fidèles à la réalité. Je recommande vivement AfriqPnB.",
            "commentEn": "My stay in Kribi was perfect. The photos and videos of the listings were true to reality. I highly recommend AfriqPnB.",
            "commenter": "Samantha M.",
            "note": 5,
            "dateFr": "Mars 2024",
            "dateEn": "March 2024",
            "source": "Google"
        },
        {
            "commentFr": "AfriqPnB est une excellente plateforme pour réserver des logements. J'ai apprécié la possibilité de payer par mobile money. Très pratique !",
            "commentEn": "AfriqPnB is an excellent platform for booking accommodations. I appreciated the ability to pay with mobile money. Very convenient!",
            "commenter": "Abdoulaye C.",
            "note": 5,
            "dateFr": "Avril 2024",
            "dateEn": "April 2024",
            "source": "Google"
        },
        {
            "commentFr": "Les vidéos des annonces sur AfriqPnB m'ont vraiment aidé à faire mon choix. J'ai passé un séjour fantastique à Kribi.",
            "commentEn": "The listing videos on AfriqPnB really helped me make my choice. I had a fantastic stay in Kribi.",
            "commenter": "Fatim O.",
            "note": 5,
            "dateFr": "Avril 2024",
            "dateEn": "April 2024",
            "source": "Google"
        },
        {
            "commentFr": "J'ai eu un excellent séjour à Douala grâce à AfriqPnB. Les photos étaient conformes à la réalité et le service client était top.",
            "commentEn": "I had an excellent stay in Douala thanks to AfriqPnB. The photos matched reality and the customer service was top-notch.",
            "commenter": "Isabelle V.",
            "note": 5,
            "dateFr": "Mai 2024",
            "dateEn": "May 2024",
            "source": "Google"
        },
        {
            "commentFr": "Le site est très bien conçu et les annonces sont détaillées avec des photos et vidéos. Mon séjour à Kribi était parfait.",
            "commentEn": "The site is very well designed and the listings are detailed with photos and videos. My stay in Kribi was perfect.",
            "commenter": "Eric G.",
            "note": 5,
            "dateFr": "Mai 2024",
            "dateEn": "May 2024",
            "source": "Google"
        },
        {
            "commentFr": "AfriqPnB a rendu mon séjour à Douala très agréable. Les informations étaient claires et précises. Je recommande fortement cette plateforme.",
            "commentEn": "AfriqPnB made my stay in Douala very pleasant. The information was clear and accurate. I highly recommend this platform.",
            "commenter": "Kadiatou B.",
            "note": 5,
            "dateFr": "Juin 2024",
            "dateEn": "June 2024",
            "source": "Google"
        },
        {
            "commentFr": "Les vidéos des annonces sur AfriqPnB sont un atout majeur. Elles m'ont aidé à choisir l'endroit parfait pour mon séjour à Kribi.",
            "commentEn": "The listing videos on AfriqPnB are a major asset. They helped me choose the perfect place for my stay in Kribi.",
            "commenter": "Thomas S.",
            "note": 5,
            "dateFr": "Juin 2024",
            "dateEn": "June 2024",
            "source": "Google"
        },
        {
            "commentFr": "AfriqPnB est une plateforme de confiance. J'ai pu réserver un magnifique appartement à Douala et tout s'est déroulé sans problème.",
            "commentEn": "AfriqPnB is a trustworthy platform. I was able to book a beautiful apartment in Douala and everything went smoothly.",
            "commenter": "Victor N.",
            "note": 5,
            "dateFr": "Juin 2024",
            "dateEn": "June 2024",
            "source": "Google"
        },
        {
            "commentFr": "J'ai beaucoup aimé la possibilité de payer par mobile money sur AfriqPnB. Mon séjour à Kribi a été une expérience formidable.",
            "commentEn": "I really liked the ability to pay with mobile money on AfriqPnB. My stay in Kribi was a great experience.",
            "commenter": "Pauline R.",
            "note": 5,
            "dateFr": "Janvier 2024",
            "dateEn": "January 2024",
            "source": "Google"
        },
        {
            "commentFr": "Les vidéos des annonces sur AfriqPnB sont géniales. Elles m'ont rassuré sur le choix de mon logement à Kribi. Très satisfait !",
            "commentEn": "The listing videos on AfriqPnB are great. They reassured me about my choice of accommodation in Kribi. Very satisfied!",
            "commenter": "Bintou H.",
            "note": 5,
            "dateFr": "Janvier 2024",
            "dateEn": "January 2024",
            "source": "Google"
        },
        {
            "commentFr": "AfriqPnB est une excellente plateforme. Les photos et vidéos des annonces sont fidèles à la réalité. Mon séjour à Douala était parfait.",
            "commentEn": "AfriqPnB is an excellent platform. The photos and videos of the listings are true to reality. My stay in Douala was perfect.",
            "commenter": "Adrienne T.",
            "note": 5,
            "dateFr": "Février 2024",
            "dateEn": "February 2024",
            "source": "Google"
        },
        {
            "commentFr": "Le paiement par mobile money est un vrai plus. J'ai passé un super séjour à Kribi grâce à AfriqPnB.",
            "commentEn": "Paying with mobile money is a real plus. I had a great stay in Kribi thanks to AfriqPnB.",
            "commenter": "Aboubacar J.",
            "note": 5,
            "dateFr": "Février 2024",
            "dateEn": "February 2024",
            "source": "Google"
        },
        {
            "commentFr": "Les vidéos des annonces sur AfriqPnB sont très utiles. Elles m'ont aidé à choisir le bon logement à Douala. Je recommande cette plateforme.",
            "commentEn": "The listing videos on AfriqPnB are very helpful. They helped me choose the right accommodation in Douala. I recommend this platform.",
            "commenter": "Françoise C.",
            "note": 5,
            "dateFr": "Mars 2024",
            "dateEn": "March 2024",
            "source": "Google"
        },
        {
            "commentFr": "AfriqPnB est une plateforme fiable. J'ai trouvé un superbe appartement à Kribi et tout était conforme aux photos.",
            "commentEn": "AfriqPnB is a reliable platform. I found a great apartment in Kribi and everything matched the photos.",
            "commenter": "Christophe V.",
            "note": 5,
            "dateFr": "Mars 2024",
            "dateEn": "March 2024",
            "source": "Google"
        },
        {
            "commentFr": "J'ai adoré mon séjour à Douala grâce à AfriqPnB. Le site est facile à utiliser et les annonces sont détaillées avec des photos et vidéos.",
            "commentEn": "I loved my stay in Douala thanks to AfriqPnB. The site is easy to use and the listings are detailed with photos and videos.",
            "commenter": "Vanessa L.",
            "note": 5,
            "dateFr": "Avril 2024",
            "dateEn": "April 2024",
            "source": "Google"
        },
        {
            "commentFr": "Les vidéos des annonces sur AfriqPnB m'ont vraiment aidé à faire mon choix. Mon séjour à Kribi était parfait. Merci !",
            "commentEn": "The listing videos on AfriqPnB really helped me make my choice. My stay in Kribi was perfect. Thank you!",
            "commenter": "Daniel E.",
            "note": 5,
            "dateFr": "Avril 2024",
            "dateEn": "April 2024",
            "source": "Google"
        },
        {
            "commentFr": "AfriqPnB propose des logements de qualité. J'ai passé un excellent séjour à Douala. Je recommande cette plateforme.",
            "commentEn": "AfriqPnB offers quality accommodations. I had an excellent stay in Douala. I recommend this platform.",
            "commenter": "Marie T.",
            "note": 5,
            "dateFr": "Mai 2024",
            "dateEn": "May 2024",
            "source": "Google"
        },
        {
            "commentFr": "Le paiement par mobile money sur AfriqPnB est très pratique. J'ai passé un séjour merveilleux à Kribi. Merci !",
            "commentEn": "Paying with mobile money on AfriqPnB is very convenient. I had a wonderful stay in Kribi. Thank you!",
            "commenter": "Benoit K.",
            "note": 5,
            "dateFr": "Mai 2024",
            "dateEn": "May 2024",
            "source": "Google"
        },
        {
            "commentFr": "AfriqPnB est une plateforme fiable et efficace. J'ai trouvé un superbe appartement à Douala et tout s'est déroulé sans problème.",
            "commentEn": "AfriqPnB is a reliable and efficient platform. I found a great apartment in Douala and everything went smoothly.",
            "commenter": "Fatou D.",
            "note": 5,
            "dateFr": "Juin 2024",
            "dateEn": "June 2024",
            "source": "Google"
        },
        {
            "commentFr": "Les vidéos des annonces sur AfriqPnB sont un atout majeur. Elles m'ont rassuré sur le choix de mon logement à Kribi.",
            "commentEn": "The listing videos on AfriqPnB are a major asset. They reassured me about my choice of accommodation in Kribi.",
            "commenter": "Jean P.",
            "note": 5,
            "dateFr": "Juin 2024",
            "dateEn": "June 2024",
            "source": "Google"
        },
        {
            "commentFr": "AfriqPnB a rendu mon séjour à Douala très agréable. Les informations étaient claires et précises. Je recommande cette plateforme.",
            "commentEn": "AfriqPnB made my stay in Douala very pleasant. The information was clear and accurate. I recommend this platform.",
            "commenter": "Brigitte N.",
            "note": 5,
            "dateFr": "Juin 2024",
            "dateEn": "June 2024",
            "source": "Google"
        },
        {
            "commentFr": "J'ai passé un excellent séjour à Kribi grâce à AfriqPnB. Les vidéos des annonces m'ont vraiment aidé à faire mon choix.",
            "commentEn": "I had an excellent stay in Kribi thanks to AfriqPnB. The listing videos really helped me make my choice.",
            "commenter": "Alain S.",
            "note": 5,
            "dateFr": "Juin 2024",
            "dateEn": "June 2024",
            "source": "Google"
        },
        {
            "commentFr": "AfriqPnB est une plateforme fiable. Les photos et vidéos des annonces sont fidèles à la réalité. Mon séjour à Douala était parfait.",
            "commentEn": "AfriqPnB is a reliable platform. The photos and videos of the listings are true to reality. My stay in Douala was perfect.",
            "commenter": "Ange M.",
            "note": 5,
            "dateFr": "Juin 2024",
            "dateEn": "June 2024",
            "source": "Google"
        }
  ]

  